export function pad(num) {
  if (num > -10 && num < 0) {
    return `-0${Math.abs(num)}`;
  }

  if (num >= 0 && num < 10) {
    return `0${num}`;
  }

  return `${num}`;
}

// Convert seconds into HH:mm:ss format
export default function hhmmss(secs, padHours = false) {
  const parsedSeconds = Math.ceil(parseFloat(secs));

  if (!parsedSeconds) {
    return `${padHours ? '00' : '0'}:00:00`;
  }

  const hours = Math.floor(parsedSeconds / 3600);
  const minutes = Math.floor((parsedSeconds % 3600) / 60);
  const seconds = parsedSeconds % 60;

  return `${padHours ? pad(hours) : hours}:${pad(minutes)}:${pad(seconds)}`;
}
